import * as React from 'react';
import Typography from '@mui/material/Typography';

import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import RunDetails from './RunDetails.tsx';

export default function RunTimelineItem() {
  return (
    <TimelineItem>
      <TimelineOppositeContent
        sx={{ 
          mx: 0, 
          my: 'auto', 
          pl: 0,
          pr: 2, 
          py: 0,
          verticalAlign: "middle", 
          width: "119px",
          minWidth: "119px",
          maxWidth: "119px",
          fontWeight: "bold",
        }}
        align="right"
        variant="body2"
        color="darkred"
      >
        10:00 AM
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot>
          <DirectionsRunIcon />
        </TimelineDot>
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent
        sx={{ 
          pt: 0
        }}
      >
        <Typography 
          variant="h6" 
          component="div"
          sx={{ 
            my: "11.5px", 
            ml: '0', 
            pr: 2, 
            pt: '0', 
            lineHeight: "36px", 
            verticalAlign: "middle", 
            fontWeight: "bold",
            width: "100%",
            color:"darkred"
          }}>
            Optional: Wedding Day Group Run
          </Typography>
        <RunDetails />
      </TimelineContent>
    </TimelineItem>
  );
}
